import React, { useState, useRef, useEffect } from 'react';

import Canvas from './canvas';
import Sorting from './sorting';
import { drawArr } from './canvas-util';

type Props = {
  type: 'quick';
};

const SortingCanvas: React.FC<Props> = ({ type }) => {
  const arr = [9, 4, 6, 3, 7, 1, 2, 11, 5];
  const fillColors = arr.map(() => '#fff');
  const fontColors = arr.map(() => '#000');

  const steps = [
    {
      arr: [...arr],
      fillColors: [...fillColors],
      fontColors: [...fontColors],
    },
  ];

  const results = Sorting[type](arr);

  for (let i = 0; i < results.length; ++i) {
    const newFontColors = [...steps[i].fontColors];
    const newFillColors = [...steps[i].fillColors];

    newFontColors[results[i].pivot] = '#28a745';
    newFillColors[results[i].pivot] = '#ffc107';

    steps.push({
      arr: results[i].arr,
      fillColors: newFillColors,
      fontColors: newFontColors,
    });
  }

  const [index, setIndex] = useState(0);
  const indexRef = useRef(0);
  const frameRef = useRef(0);
  const requestRef = useRef(null);
  const delayFrame = 40;

  const animate = () => {
    if (frameRef.current >= delayFrame) {
      frameRef.current =
        indexRef.current === steps.length - 2 ? -delayFrame : 0;

      if (indexRef.current < steps.length - 1) {
        setIndex(prev => prev + 1);
        indexRef.current += 1;
      } else {
        setIndex(0);
        indexRef.current = 0;
      }
    }

    frameRef.current += 1;
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, []);

  const draw = (
    canvasRef: React.MutableRefObject<HTMLCanvasElement>,
    ctx: CanvasRenderingContext2D
  ): void => {
    drawArr(canvasRef.current, ctx, steps[index].arr, {
      fillColors: steps[index].fillColors,
      fontColors: steps[index].fontColors,
    });
  };

  return <Canvas paint={draw} />;
};

export default SortingCanvas;
